module.exports = __webpack_public_path__ + "img/iona_transbg.6802a478.png";